module.exports = __webpack_public_path__ + "static/media/icon-bookings.e2cd6145.svg";